import { Cube, Tag, User } from "assets/icons";
import { SelectField } from "components/form/fields";
import { FC } from "react";
import { IFieldType, IOption } from "types";

interface Props {
  themaOptions: IOption[];
  targetAudienceOptions: IOption[];
  materialOptions: IOption[];
  setThema: (thema: string | null) => void;
  setTargetAudience: (targetAudience: string | null) => void;
  setMaterial: (thema: string | null) => void;
}

export const TableFilters: FC<Props> = ({
  themaOptions = [],
  targetAudienceOptions = [],
  materialOptions = [],
  setThema,
  setTargetAudience,
  setMaterial,
}) => {
  return (
    <div className="table-overview-filters">
      <SelectField
        options={themaOptions}
        placeholder="Thema"
        prefixText="Ik zoek"
        hideLabel
        type={IFieldType.select}
        labelIcon={<Tag />}
        name="Thema"
        label="Thema"
        onChange={({ currentTarget: { value } }) => setThema(value)}
      />
      <SelectField
        options={targetAudienceOptions}
        prefixText="voor"
        placeholder="Doelgroep"
        hideLabel
        type={IFieldType.select}
        labelIcon={<User />}
        name="Doelgroep"
        label="Doelgroep"
        onChange={({ currentTarget: { value } }) => setTargetAudience(value)}
      />
      <SelectField
        options={materialOptions}
        prefixText="in de vorm van"
        placeholder="Materiaal"
        hideLabel
        type={IFieldType.select}
        labelIcon={<Cube />}
        name="Materiaal"
        label="Materiaal"
        onChange={({ currentTarget: { value } }) => setMaterial(value)}
      />
    </div>
  );
};
